module.exports = __webpack_public_path__ + "static/media/Matt Piper_2019.30ced01b.jpg";